<form [formGroup]="form"
      (ngSubmit)="create()">

  <p class="body2Font"
     i18n>Add keywords manually</p>

  <div class="formgrid grid">
    <div class="field col-12">
      <editor formControlName="keyword"
              scValidatable
              scLabelText="Keyword"
              i18n-scLabelText
              placeholder="Type keyword(s)"
              i18n-placeholder
              class="w-full">
      </editor>
    </div>

    <div class="field field-checkbox py-3 col-12 flex align-items-center">
      <p-checkbox [binary]="true"
                  formControlName="splitAndCapitalize"
                  inputId="splitAndCapitalize" />
      <label for="splitAndCapitalize"
             class="ml-2"
             i18n>Pre-process keywords (split, capitalize etc.)</label>
    </div>
  </div>

  <p-button scSubmitButton
            [requestInProcess]="requestInProcess"
            class="flex justify-content-center mt-3"
            label="Save"
            i18n-label>
  </p-button>
</form>